export const en = {
    all: 'All',
    'find-platforms': 'Find advertising surfaces',
    format: 'Format',
    operator: 'Operator',
    selected: 'Selected'
};
